import { useStyles } from '@archipro-design/aria';
import { ArticleTileSkeletonMobile } from './ArticleTileSkeleton.mobile';
import * as S from '../articles-carousel/ArticlesCarousel.style';
interface ArticleCarouselPlaceholderProps {
    title: string;
    tileLength?: number;
}
export const ArticleCarouselPlaceholderMobile: React.FC<
    ArticleCarouselPlaceholderProps
> = ({ title, tileLength = 1 }) => {
    const { css } = useStyles();

    return (
        <div>
            <div className={css(S.MobileTitle)}>{title}</div>
            {Array.from(Array(tileLength).keys()).map((key) => (
                <div className={css(S.MobilePlaceholderContainer)} key={key}>
                    <ArticleTileSkeletonMobile />
                </div>
            ))}
        </div>
    );
};
